import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-inner-videos',
  templateUrl: './inner-videos.component.html',
  styleUrls: ['./inner-videos.component.scss']
})
export class InnerVideosComponent implements OnInit {
  @Input() data: any;
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.data && Array.isArray(this.data)) {
      this.data.sort((a, b) => {
        const dateA = this.parseDate(a.date);
        const dateB = this.parseDate(b.date);
        return dateB.getTime() - dateA.getTime(); // Sort by latest date first
      });
    }
  }

  parseDate(dateStr: string): Date {
    if (!dateStr) return new Date(''); // Invalid fallback
  
    // Normalize all separators to '-'
    const normalized = dateStr.replace(/[.\s]/g, '-'); // Converts "27.03.2025" or "27 03 2025" to "27-03-2025"
    const [day, month, year] = normalized.split('-').map(part => parseInt(part, 10));
  
    return new Date(year, month - 1, day); // month is 0-indexed in Date
  }
}
